import React from 'react';
import PropTypes from 'prop-types';
import '../styles/loader.scss';

const Loader = ({ title, negative }) => (
  <div className={`loader-background ${negative ? 'negative' : ''}`}>
    <div className="loader">
      <svg className="circular" viewBox="25 25 50 50">
        <circle
          className="path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke={negative ? 'white' : 'black'}
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </svg>
      {title && <div className="label">{title}</div>}
    </div>
  </div>
);

Loader.propTypes = {
  title: PropTypes.string,
  negative: PropTypes.bool,
};

Loader.defaultProps = {
  title: '',
  negative: false,
};

export default Loader;
